"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _createIconComponent = _interopRequireDefault(require("../utils/createIconComponent"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const LinkIcon = (0, _createIconComponent.default)({
  content: ( /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("g", {
    clipPath: "url(#clip0_349_948)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M7.55 5.494l2.94-2.936a2.057 2.057 0 012.907 0 2.05 2.05 0 010 2.901l-2.94 2.936 1.415 1.414 2.94-2.936a4.046 4.046 0 000-5.729 4.06 4.06 0 00-5.736 0L6.136 4.08 7.55 5.494zM6.116 6.926L4.701 5.512 1.188 9.021a4.046 4.046 0 000 5.728 4.06 4.06 0 005.736 0l3.514-3.508-1.416-1.414-3.513 3.509a2.057 2.057 0 01-2.906 0 2.05 2.05 0 010-2.902l3.513-3.508z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M5.787 11.732a1.015 1.015 0 01-1.434 0 1.012 1.012 0 010-1.431l5.737-5.729a1.015 1.015 0 011.434 0 1.012 1.012 0 010 1.432l-5.737 5.729z"
  })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
    id: "clip0_349_948"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M0 0h16v16H0z"
  })))))
});
LinkIcon.displayName = 'LinkIcon';
var _default = exports.default = LinkIcon;